import Splide from '@splidejs/splide';

export default function () {
	let eventCarousel: HTMLElement|null = document.querySelector('.event-intro__slider');
	if (!eventCarousel) return;
	new Splide(eventCarousel, {
		type       : 'fade',
		rewind     : true,
		autoplay   : true,
		interval   : 5000,
		pauseOnHover: true,
		arrows     : false,
		pagination : true,
		drag: true,
	}).mount();
}
